import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,
  ...(IS_ADMIN ? { LOGIN_BACKGROUND: '#24272a' } : {}),
  SELECTED_MENU_BG: '#19191b',
  PRIMARY_MAIN: '#19191b',
  HEADER_COUNT_TEXT: '#fff',
  PRIMARY_CONTRAST: '#fff',
  PRIMARY_BORDER: 'rgba(255,255,255,0.3)',
  GREY: '#999',
  DAILY_LOG_GRAPH_BORDER: '#919191',
  NORMAL_LINK: '#b0b0b0',
  MODAL_TEXT: '#797979',
  MODAL_HEADING: '#fff',
  MODAL_BACKGROUND: '#19191b',
  LIST_TEXT: '#b4b7c0',
  HEADER_LIST_TEXT: '#b4b7c0',
  LIGHT_BORDER: '#2d2b2b',
  SECONDARY_MAIN: '#f7931d',
  WHITE: '#fff',
  INPUT_BACKGROUND: '#19191b',
  RED: '#ff0000',
  BLACK: '#000',
  BACKGROUND: '#1b1b1b',
  BLACK_THREE: '#373737',
  RED_TWO: '#d34343',
  GREEN: '#32cd32',
  GREEN_TWO: '#97AE46',
  GREY_ELEVEN: '#777070',
  GREY_TWELVE: '#c3c3c3',
  BLACK_FOUR: '#333333',
  GRAPH_BLACK: '#212121',
  CHART_BLUE: '#00e2ff',
  WARNING: '#ffff00',
  GREY_DATA: '#696969',
  SELECTED_TAB_COLOR: '#f7931d',
  LINK_COLOR: '#f7931d',
  HEADER_COLOR: '#24272a',
  DOCUMENT_LINE: 'rgba(186, 194, 255, 0.08)',
  INPUT_BORDER: 'rgba(255,255,255,0.3)',
  DIABLED_COLOR: '#b4b7c0',
  RADIO_BACKGROUND: '#19191b',
  FORM_COLOR: '#dbdbdb',
  SUGGESTED_COLOR: '#00b7a0',
  BODY_BACKGROUND: '#19191b',
  CHECKBOX_TICK: '#f7931d',
  PAGINATION_BACKGROUND: '#19191b',
  PAGINATION_COLOR: '#fff',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
  LOGOUT_ICON: '#fff',
  MAP: {
    LIGHT_BLACK: '#353740',
    LIGHTER_BLACK: '#353740',
    BLACK: '#353740',
    GREY: '#d1d1d1',
    LIGHT_GREY: '#d1d1d1',
    LIGHTER_GREY: '#d1d1d1',
    WATER: '#5e5f67',
    ROAD: '#37425C',
  },
  LOGIN_BUTTON: '#f7931d',
  TITLE_COLOR: '#fff',
  INPUT_COLOR: '#fff',
  INPUT_FOCUS: '#5ab8f9',
  TAB_LABEL: '#455560',
  BACKGROUND_MENU: '#2c2e33',
  PAGINATION_ALTERNATE_BACKGROUND: '#1e1d20',
  TABLE_ROW_COLOR: 'rgba(222, 231, 255, 0.75)',
  SORT_ICON: '#fff',
  LOGOUT_BUTTON: '#19191b',
  PAGINATION_HEADER: '#b4b7c0',
  HEADER_TEXT: '#fff',
  PAGINATION_BORDER: 'rgba(186, 194, 255, 0.08)',
  RESET_BUTTON: 'rgba(0, 0, 0, 0.3)',
  ACTION_BORDER: 'rgba(255, 255, 255, 0.66)',
  PRIMARY_BUTTON_TEXT: '#fff',
  FORM_INPUT_BG: '#19191b',
  FORM_BACKGROUND: '#19191b',
  CHECKBOX_BORDER: 'rgba(255,255,255,0.3)',
  SELECT_ACTIONS: '#fff',
  SECONDARY_BORDER: 'rgba(186, 194, 255, 0.08)',
  MULTISELECT_BACKGROUND: '#24272a',
  MULTISELECT_LABEL: '#fff',
  TAB_HIGHLIGHT: '#fff',
  TAB_HIGHLIGHT_BACKGROUND: '#2c2e33',
  TAB_BOTTOM_BORDER: '#f7931d',
  ACCORDION_BACKGROUND: '#24272a',
  USER_LOGO_BACKGROUND: '#19191b',
  USER_LOGO_COLOR: '#f7931d',
  POLICIES_BACKGROUND: '#24272a',
  MENU_TITLE: 'rgba(255, 255, 255, 0.8)',
  SELECTED_MENU_TITLE: '#fff',
  MENU_BORDER_COLOR: '#f7931d',
  MENU_BACKGROUND: '#24272a',
  RANGE_PICKER: {
    CELL_BG: '#585858',
    CELL_HOVER_BG: '#333333',
  },
};
export default colors;
export const fonts = ['Open Sans', 'sans-serif'].join(',');
